import React, { useEffect } from "react";

export function useParallax({
  container,
  target,
  factor,
}: {
  container: React.RefObject<HTMLElement>;
  target: React.RefObject<HTMLElement>;
  factor: number;
}) {
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = container.current?.scrollTop ?? 0;
      target.current?.style.setProperty("--scroll-offset", `${scrollPosition}px`);
    };

    const containerEl = container.current;

    containerEl?.addEventListener("scroll", handleScroll);
    return () => {
      containerEl?.removeEventListener("scroll", handleScroll);
    };
  }, [container, factor, target]);
}
